export default {
  asset: {
    pageTitle: '账户资产 Account Assets',
    holdingsInfo: '持仓信息 Holdings Information',
    transactionHistory: '交易记录 Transaction History',
    parameterExplanation: '参数解释 Parameter Explanation',
    confirmPrice: '确认价格',
    holdingReturn: '累计收益率',
    cumulativeSubscription: '累计认购',
    cumulativeRedemption: '累计赎回',
    navDate: '净值日期',
    navValue: '持有金额',
    holdingShares: '持仓份额',
    currentNav: '当前净值',
    exportData: '导出',
    noData: '暂无数据',
    pendingPrice: '--',
    units: '份',
    filterFund: '基金筛选',
    filterType: '类型筛选',
    filterDate: '时间范围',
    all: '全部',
    issue: '认购',
    redeem: '赎回',
    eq: 'EQ',
    fundName: '基金名称',
    totalFunds: '共 {count} 只基金',
    shares: '份额',
    nav: '净值',
    filterStartDate: '开始日期',
    filterEndDate: '结束日期',
    exportFilename: '交易记录',
  },
};
